"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS = void 0;
exports.normalizeUserMultiAnalysisSettings = normalizeUserMultiAnalysisSettings;
exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS = {
    showStandardTemplates: true,
    showPublicTemplates: true,
    configureTemplateFiltersManually: false,
    showTrendsPanel: true,
};
function isPlainObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function normalizeBoolean(value, fallback) {
    return typeof value === "boolean" ? value : fallback;
}
function normalizeUserMultiAnalysisSettings(raw) {
    if (!isPlainObject(raw)) {
        return { ...exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS };
    }
    return {
        showStandardTemplates: normalizeBoolean(raw.showStandardTemplates, exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS.showStandardTemplates),
        showPublicTemplates: normalizeBoolean(raw.showPublicTemplates, exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS.showPublicTemplates),
        configureTemplateFiltersManually: normalizeBoolean(raw.configureTemplateFiltersManually, exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS.configureTemplateFiltersManually),
        showTrendsPanel: normalizeBoolean(raw.showTrendsPanel, exports.DEFAULT_USER_MULTI_ANALYSIS_SETTINGS.showTrendsPanel),
    };
}
//# sourceMappingURL=user-multi-analysis-settings.js.map